import {
  REGISTER_ACCOUNTS_USER,
  REGISTER_ACCOUNTS_USER_SUCCESS,
  REGISTER_ACCOUNTS_USER_FAILURE,
  ONBOARDING_HYDRATE_REQUEST,
  ONBOARDING_HYDRATE_SUCCESS,
  ONBOARDING_HYDRATE_FAILURE,
  ONBOARDING_SAVE_BUSINESS_REQUEST,
  ONBOARDING_SAVE_BUSINESS_SUCCESS,
  ONBOARDING_SAVE_BUSINESS_FAILURE,
  ONBOARDING_SAVE_PRODUCTION_REQUEST,
  ONBOARDING_SAVE_PRODUCTION_SUCCESS,
  ONBOARDING_SAVE_PRODUCTION_FAILURE,
  ONBOARDING_SAVE_SALES_REQUEST,
  ONBOARDING_SAVE_SALES_SUCCESS,
  ONBOARDING_SAVE_SALES_FAILURE,
  ONBOARDING_FINALIZE_REQUEST,
  ONBOARDING_FINALIZE_SUCCESS,
  ONBOARDING_FINALIZE_FAILURE,
  ONBOARDING_SAVE_BRANDING_REQUEST,
  ONBOARDING_SAVE_BRANDING_SUCCESS,
  ONBOARDING_SAVE_BRANDING_FAILURE,
  ONBOARDING_SAVE_PRICING_REQUEST,
  ONBOARDING_SAVE_PRICING_SUCCESS,
  ONBOARDING_SAVE_PRICING_FAILURE,
  ONBOARDING_SAVE_PRODUCTS_REQUEST,
  ONBOARDING_SAVE_PRODUCTS_SUCCESS,
  ONBOARDING_SAVE_PRODUCTS_FAILURE,
  ONBOARDING_SAVE_PRINT_OPTIONS_REQUEST,
  ONBOARDING_SAVE_PRINT_OPTIONS_SUCCESS,
  ONBOARDING_SAVE_PRINT_OPTIONS_FAILURE,
  ONBOARDING_SAVE_STORE_REQUEST,
  ONBOARDING_SAVE_STORE_SUCCESS,
  ONBOARDING_SAVE_STORE_FAILURE,
  ONBOARDING_ENRICH_WEBSITE_REQUEST,
  ONBOARDING_ENRICH_WEBSITE_SUCCESS,
  ONBOARDING_ENRICH_WEBSITE_FAILURE,
} from "../constants/actionTypes";

// ── Founder signup (Step 1) ───────────────────────────────────────────

/**
 * @param {Object} payload
 *   - { email, password }                 — email/password flow
 *   - { email, uid, displayName?, ... }   — Google flow (uid from popup)
 */
export const registerAccountsUser = (payload) => ({
  type: REGISTER_ACCOUNTS_USER,
  payload,
});

export const registerAccountsUserSuccess = (user) => ({
  type: REGISTER_ACCOUNTS_USER_SUCCESS,
  payload: user,
});

export const registerAccountsUserFailure = (message) => ({
  type: REGISTER_ACCOUNTS_USER_FAILURE,
  payload: message,
});

// ── Onboarding wizard (Steps 2-5) ─────────────────────────────────────

export const hydrateOnboarding = () => ({ type: ONBOARDING_HYDRATE_REQUEST });
export const hydrateOnboardingSuccess = (state) => ({
  type: ONBOARDING_HYDRATE_SUCCESS,
  payload: state,
});
export const hydrateOnboardingFailure = (message) => ({
  type: ONBOARDING_HYDRATE_FAILURE,
  payload: message,
});

export const saveBusinessProfile = (data) => ({
  type: ONBOARDING_SAVE_BUSINESS_REQUEST,
  payload: data,
});
export const saveBusinessProfileSuccess = (data) => ({
  type: ONBOARDING_SAVE_BUSINESS_SUCCESS,
  payload: data,
});
export const saveBusinessProfileFailure = (message) => ({
  type: ONBOARDING_SAVE_BUSINESS_FAILURE,
  payload: message,
});

export const saveProduction = (data) => ({
  type: ONBOARDING_SAVE_PRODUCTION_REQUEST,
  payload: data,
});
export const saveProductionSuccess = (data) => ({
  type: ONBOARDING_SAVE_PRODUCTION_SUCCESS,
  payload: data,
});
export const saveProductionFailure = (message) => ({
  type: ONBOARDING_SAVE_PRODUCTION_FAILURE,
  payload: message,
});

export const saveSales = (data) => ({
  type: ONBOARDING_SAVE_SALES_REQUEST,
  payload: data,
});
export const saveSalesSuccess = (data) => ({
  type: ONBOARDING_SAVE_SALES_SUCCESS,
  payload: data,
});
export const saveSalesFailure = (message) => ({
  type: ONBOARDING_SAVE_SALES_FAILURE,
  payload: message,
});

export const finalizeOnboarding = (data) => ({
  type: ONBOARDING_FINALIZE_REQUEST,
  payload: data,
});
export const finalizeOnboardingSuccess = (result) => ({
  type: ONBOARDING_FINALIZE_SUCCESS,
  payload: result,
});
export const finalizeOnboardingFailure = (message) => ({
  type: ONBOARDING_FINALIZE_FAILURE,
  payload: message,
});

// ── Extended steps: branding/URL → pricing → products → print-options → store ──

export const saveOnboardingBranding = (data) => ({
  type: ONBOARDING_SAVE_BRANDING_REQUEST,
  payload: data,
});
export const saveOnboardingBrandingSuccess = (data) => ({
  type: ONBOARDING_SAVE_BRANDING_SUCCESS,
  payload: data,
});
export const saveOnboardingBrandingFailure = (message) => ({
  type: ONBOARDING_SAVE_BRANDING_FAILURE,
  payload: message,
});

export const saveOnboardingPricing = (data) => ({
  type: ONBOARDING_SAVE_PRICING_REQUEST,
  payload: data,
});
export const saveOnboardingPricingSuccess = (data) => ({
  type: ONBOARDING_SAVE_PRICING_SUCCESS,
  payload: data,
});
export const saveOnboardingPricingFailure = (message) => ({
  type: ONBOARDING_SAVE_PRICING_FAILURE,
  payload: message,
});

export const saveOnboardingProducts = (data) => ({
  type: ONBOARDING_SAVE_PRODUCTS_REQUEST,
  payload: data,
});
export const saveOnboardingProductsSuccess = (data) => ({
  type: ONBOARDING_SAVE_PRODUCTS_SUCCESS,
  payload: data,
});
export const saveOnboardingProductsFailure = (message) => ({
  type: ONBOARDING_SAVE_PRODUCTS_FAILURE,
  payload: message,
});

export const saveOnboardingPrintOptions = (data) => ({
  type: ONBOARDING_SAVE_PRINT_OPTIONS_REQUEST,
  payload: data,
});
export const saveOnboardingPrintOptionsSuccess = (data) => ({
  type: ONBOARDING_SAVE_PRINT_OPTIONS_SUCCESS,
  payload: data,
});
export const saveOnboardingPrintOptionsFailure = (message) => ({
  type: ONBOARDING_SAVE_PRINT_OPTIONS_FAILURE,
  payload: message,
});

export const saveOnboardingStore = (data) => ({
  type: ONBOARDING_SAVE_STORE_REQUEST,
  payload: data,
});
export const saveOnboardingStoreSuccess = (data) => ({
  type: ONBOARDING_SAVE_STORE_SUCCESS,
  payload: data,
});
export const saveOnboardingStoreFailure = (message) => ({
  type: ONBOARDING_SAVE_STORE_FAILURE,
  payload: message,
});

// ── Website enrichment (logo + brand color + city/state) ──────────────

export const enrichWebsite = (url) => ({
  type: ONBOARDING_ENRICH_WEBSITE_REQUEST,
  payload: url,
});
export const enrichWebsiteSuccess = (enrichment) => ({
  type: ONBOARDING_ENRICH_WEBSITE_SUCCESS,
  payload: enrichment,
});
export const enrichWebsiteFailure = (message) => ({
  type: ONBOARDING_ENRICH_WEBSITE_FAILURE,
  payload: message,
});
